import React from 'react';
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Button from 'aquilla/core/molecules/Button';
import Play from 'aquilla/icons/actions/Play';
import Avatar from '@icon/Content/Avatar';
import Clock from '@icon/Content/Clock';
import useLessonDetails from './useLessonDetails';
import { getAuthorName } from './utils';
import { SIDE_CARD } from './constants/events';

const Wrapper = styled.div`
  display: grid;
  margin: auto;
  padding: ${Spacings.SPACING_4B};
  gap: ${Spacings.SPACING_3B};
  width: 336px;
  height: 224px;
  position: sticky;
  background: var(--color-i-white);
  border: ${Spacings.SPACING_1} solid #dde6ed;
  border-radius: ${Spacings.SPACING_2B};
  top: 10%;
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

const Title = styled(Typography)`
  margin-bottom: ${Spacings.SPACING_1B};
`;

const IconTextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacings.SPACING_2B};
`;
const StyledButton = styled(Button)`
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_6B};
  gap: ${Spacings.SPACING_1B};
  width: 100%;
  max-width: 304px;
  height: 48px;
  margin-top: ${Spacings.SPACING_1B};
`;

const Text = styled(Typography)``;

const IconText = ({ text, icon }) => {
  return (
    <IconTextWrapper>
      {icon}
      <Text variant="p2">{text}</Text>
    </IconTextWrapper>
  );
};
const LessonCard = ({ playlistUID, handlePlayCTA }) => {
  const { lessonDetails, learnerMeta } = useLessonDetails(playlistUID);
  const author = lessonDetails?.authors?.[0] || {};
  const authorFullName = getAuthorName(author);

  const handleStartWatchingClick = () => {
    handlePlayCTA({
      last_primary_source_section: SIDE_CARD,
      CTA_name: learnerMeta?.ctaHeader
    });
  };

  return (
    <Wrapper>
      <Title variant="h4">{lessonDetails.name}</Title>
      {lessonDetails?.lessonsCount && (
        <IconText
          text={`${lessonDetails.lessonsCount} lessons`}
          icon={<Clock />}
        />
      )}
      {authorFullName && <IconText text={authorFullName} icon={<Avatar />} />}
      <StyledButton
        label={learnerMeta?.ctaHeader || 'Start watching'}
        onClick={handleStartWatchingClick}
        size="large"
        variant="primary"
        startIcon={<Play color="primary" width="12" height="12" />}
      />
    </Wrapper>
  );
};

export default LessonCard;
